export default "__VITE_ASSET__DpSzvSZk__"